function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { withStyles } from "@material-ui/core/styles";
import React, { Component } from "react";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import { compose } from "redux";
import PrismicClient from "@common/utils/prismic";
import { getInvoiceList, getInvoiceUrl } from "@common/actions";
import { formatDate, formatPrice } from "@common/services/helpers";
import CustomScrollbar from "@common/components/CustomScrollbar";
import { SCROLLBAR } from "@common/services/responsive";
import { KEY_ENTER, KEY_SPACE, TOOLTIP_SHOW_DELAY } from "@config/constants";
import InvoiceInformationCard from "./InvoiceInformationCard";
var styles = function() {
    return {
        head: {
            backgroundColor: "#fff",
            position: "sticky",
            marginBottom: 5,
            top: 0
        }
    };
};
var InvoicesTable = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(InvoicesTable, Component);
    var _super = _create_super(InvoicesTable);
    function InvoicesTable(props) {
        _class_call_check(this, InvoicesTable);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            prismicSubscriptions: null
        };
        _this.handleKeydown = _this.handleKeydown.bind(_assert_this_initialized(_this));
        _this.getInvoiceUrl = _this.getInvoiceUrl.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(InvoicesTable, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return _async_to_generator(function() {
                    var prismicSubscriptions;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.props.getInvoiceList()
                                ];
                            case 1:
                                _state.sent();
                                if (!PrismicClient.hasPrismic()) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    PrismicClient.getSubscriptions("BG")
                                ];
                            case 2:
                                prismicSubscriptions = _state.sent();
                                _this.setState({
                                    prismicSubscriptions: prismicSubscriptions
                                });
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Download invoice pdf on enter/space keydown
     * @params event {Object} invoiceId {String}
     */ key: "handleKeydown",
            value: function handleKeydown(event, invoiceId) {
                var key = event.which;
                if (key === KEY_SPACE || key === KEY_ENTER) {
                    event.preventDefault();
                    this.getInvoiceUrl(invoiceId);
                }
            }
        },
        {
            key: "getInvoiceUrl",
            value: /**
     * Make a request for the invoice url and download it
     * @param invoiceId {String}
     */ function getInvoiceUrl(invoiceId) {
                var _this = this;
                return _async_to_generator(function() {
                    var _$getInvoiceUrl, _this_props, invoice;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _$getInvoiceUrl = _this.props.getInvoiceUrl;
                                return [
                                    4,
                                    _$getInvoiceUrl(invoiceId)
                                ];
                            case 1:
                                _state.sent();
                                _this_props = _this.props, invoice = _this_props.userDetails.invoice;
                                if (invoice) {
                                    window.location.href = invoice.downloadURL;
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Renders the table cells.
     * @returns {*}
     */ key: "renderTableCells",
            value: function renderTableCells(invoices) {
                var _this = this;
                var _userDetails_billingAddress, _this_state_prismicSubscriptions;
                var _this_props = this.props, i18n = _this_props.i18n, userDetails = _this_props.userDetails;
                var _userDetails_billingAddress_country;
                var country = (_userDetails_billingAddress_country = userDetails === null || userDetails === void 0 ? void 0 : (_userDetails_billingAddress = userDetails.billingAddress) === null || _userDetails_billingAddress === void 0 ? void 0 : _userDetails_billingAddress.country) !== null && _userDetails_billingAddress_country !== void 0 ? _userDetails_billingAddress_country : userDetails === null || userDetails === void 0 ? void 0 : userDetails.predifinedCountryCode;
                var showEuro = ((_this_state_prismicSubscriptions = this.state.prismicSubscriptions) === null || _this_state_prismicSubscriptions === void 0 ? void 0 : _this_state_prismicSubscriptions.conversion_rate) && (country === "BG" || country === "Bulgaria");
                return invoices.map(function(invoice) {
                    var _this_state_prismicSubscriptions, _this_state_prismicSubscriptions1, _this_state_prismicSubscriptions2, _this_state_prismicSubscriptions3;
                    return /*#__PURE__*/ _jsxs(TableRow, {
                        children: [
                            /*#__PURE__*/ _jsx(TableCell, {
                                children: formatDate(invoice.paidAt)
                            }),
                            /*#__PURE__*/ _jsxs(TableCell, {
                                children: [
                                    showEuro ? "".concat(formatPrice(invoice.amountPaid, "EUR", {
                                        conversion_rate: (_this_state_prismicSubscriptions = _this.state.prismicSubscriptions) === null || _this_state_prismicSubscriptions === void 0 ? void 0 : _this_state_prismicSubscriptions.conversion_rate,
                                        currency: "BGN"
                                    }), " / ").concat(formatPrice(invoice.amountPaid, invoice.currencyCode)) : formatPrice(invoice.amountPaid, invoice.currencyCode),
                                    "  "
                                ]
                            }),
                            /*#__PURE__*/ _jsx(TableCell, {
                                children: invoice.amountAdjusted ? showEuro ? "".concat(formatPrice(invoice.amountAdjusted, "EUR", {
                                    conversion_rate: (_this_state_prismicSubscriptions1 = _this.state.prismicSubscriptions) === null || _this_state_prismicSubscriptions1 === void 0 ? void 0 : _this_state_prismicSubscriptions1.conversion_rate,
                                    currency: "BGN"
                                }), " / ").concat(formatPrice(invoice.amountAdjusted, invoice.currencyCode)) : formatPrice(invoice.amountAdjusted, invoice.currencyCode) : "––"
                            }),
                            /*#__PURE__*/ _jsxs(TableCell, {
                                children: [
                                    showEuro ? "".concat(formatPrice(invoice.creditsApplied, "EUR", {
                                        conversion_rate: (_this_state_prismicSubscriptions2 = _this.state.prismicSubscriptions) === null || _this_state_prismicSubscriptions2 === void 0 ? void 0 : _this_state_prismicSubscriptions2.conversion_rate,
                                        currency: "BGN"
                                    }), " / ").concat(formatPrice(invoice.creditsApplied, invoice.currencyCode)) : formatPrice(invoice.creditsApplied, invoice.currencyCode),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(TableCell, {
                                children: [
                                    showEuro ? "".concat(formatPrice(invoice.total, "EUR", {
                                        conversion_rate: (_this_state_prismicSubscriptions3 = _this.state.prismicSubscriptions) === null || _this_state_prismicSubscriptions3 === void 0 ? void 0 : _this_state_prismicSubscriptions3.conversion_rate,
                                        currency: "BGN"
                                    }), " / ").concat(formatPrice(invoice.total, invoice.currencyCode)) : formatPrice(invoice.total, invoice.currencyCode),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ _jsx(TableCell, {
                                children: /*#__PURE__*/ _jsxs("span", {
                                    className: "icon icon-pdf pointer",
                                    tabIndex: "0",
                                    "data-for": "invoice-tooltip",
                                    "data-tip": i18n.account.downloadInvoice,
                                    onKeyDown: function(event) {
                                        return _this.handleKeydown(event, invoice.id);
                                    },
                                    onClick: function() {
                                        return _this.getInvoiceUrl(invoice.id);
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "path1"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "path2"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "path3"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "path4"
                                        })
                                    ]
                                })
                            })
                        ]
                    }, invoice.id);
                });
            }
        },
        {
            /**
     * Renders the invoice cards.
     * @returns {*}
     */ key: "renderInvoiceCards",
            value: function renderInvoiceCards(invoices) {
                var _this = this;
                return invoices.map(function(invoice) {
                    return /*#__PURE__*/ _jsx(InvoiceInformationCard, {
                        getInvoiceUrl: _this.getInvoiceUrl,
                        invoice: invoice
                    }, invoice.id);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, classes = _this_props.classes, userDetails = _this_props.userDetails, i18n = _this_props.i18n, screenType = _this_props.screenType;
                var invoicesTable = /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsxs(Table, {
                            className: "invoices-table",
                            children: [
                                /*#__PURE__*/ _jsx(TableHead, {
                                    children: /*#__PURE__*/ _jsxs(TableRow, {
                                        children: [
                                            /*#__PURE__*/ _jsx(TableCell, {
                                                className: classes.head,
                                                children: i18n.account.date
                                            }),
                                            /*#__PURE__*/ _jsx(TableCell, {
                                                className: classes.head,
                                                children: i18n.account.sum
                                            }),
                                            /*#__PURE__*/ _jsx(TableCell, {
                                                className: classes.head,
                                                children: i18n.account.correction
                                            }),
                                            /*#__PURE__*/ _jsx(TableCell, {
                                                className: classes.head,
                                                children: i18n.account.credits
                                            }),
                                            /*#__PURE__*/ _jsx(TableCell, {
                                                className: classes.head,
                                                children: i18n.common.total
                                            }),
                                            /*#__PURE__*/ _jsx(TableCell, {
                                                className: classes.head,
                                                children: i18n.account.invoices
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(TableBody, {
                                    children: /*#__PURE__*/ _jsx(_Fragment, {
                                        children: userDetails.invoicesList ? this.renderTableCells(userDetails.invoicesList) : null
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "invoice-cards-wrapper",
                            children: userDetails.invoicesList ? this.renderInvoiceCards(userDetails.invoicesList) : null
                        })
                    ]
                });
                return /*#__PURE__*/ _jsxs("div", {
                    className: "invoices-wrapper",
                    children: [
                        /*#__PURE__*/ _jsx(ReactTooltip, {
                            id: "invoice-tooltip",
                            className: "tooltip",
                            delayShow: TOOLTIP_SHOW_DELAY,
                            disable: !screenType.web,
                            place: "bottom",
                            effect: "solid"
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "invoices-title",
                            children: i18n.account.invoicePayments
                        }),
                        screenType.web ? /*#__PURE__*/ _jsx(CustomScrollbar, {
                            className: "invoices-scrollbar",
                            hideTracksWhenNotNeeded: true,
                            style: {
                                width: SCROLLBAR.INVOICES.width,
                                height: SCROLLBAR.INVOICES.height
                            },
                            thumbSize: SCROLLBAR.INVOICES.thumbSize,
                            children: invoicesTable
                        }) : invoicesTable,
                        userDetails.invoices && userDetails.invoices.length === 0 ? /*#__PURE__*/ _jsx("span", {
                            className: "no-invoices",
                            children: i18n.account.noInvoices
                        }) : null
                    ]
                });
            }
        }
    ]);
    return InvoicesTable;
}(Component);
export default compose(withStyles(styles, {
    name: "InvoicesTable"
}), connect(null, {
    getInvoiceUrl: getInvoiceUrl,
    getInvoiceList: getInvoiceList
}))(InvoicesTable);
